import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import SectionMenu from "/react4xp/components/shared/SectionMenu/SectionMenu";

import type { SectionMenuPartProps } from "./SectionMenu.d";

export const SectionMenuPart = (props: ComponentProps<PartData>) => {
  const { menus, title, pageType } = (props.data as SectionMenuPartProps) ?? {};

  return (
    <section className={`bg-forest${pageType ? `-${pageType}` : ""}`}>
      <div className="wide-container">
        <SectionMenu menus={menus} title={title} />
      </div>
    </section>
  );
};

export default SectionMenuPart;
